import styled from 'styled-components';

import {
  Editor,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  spacing: 10,
  align: 'center',
  justify: 'space-between',
})`
  color: #fff;
  padding: 20px;
  margin: -1px -1px 0 -1px;
  width: calc(100% + 2px);
  background: ${props => props.theme.colors.primary};
  border-radius: 6px 6px 0 0;
  position: relative;
`;

export const Description = styled(Editor).attrs({
  isInline: true,
})`
  color: #2f3539;
  font-size: 14px;
  line-height: 18px;
  width: 100%;
  border: 1px dashed transparent;

  &:hover,
  &:focus {
    border-color: ${props => props.theme.colors.primary};
  }

  @media print {
    padding: 0;
    margin: -15px 0 0 -15px;
    ${props => !props.defaultValue && `
      display: none
    `}
  };
`;

export const DieRoll = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 0;
  z-index: 1;

  span {
    color: ${props => props.theme.colors.primary};
    margin-right: 5px;
  }
`;
